import type { FaireProductEntity } from "../../entity_types/product";

export const p_t4qjmtqa5p: FaireProductEntity = {
  token: "p_t4qjmtqa5p",
  type: "product",
  name: "Colorful Evil Eye Gold Chain Necklace – A Modern Pendant",
  brandToken: "b_eh970f9ptb",
  brandName: "Loli",
  imageUrl:
    "https://cdn.faire.com/fastly/1c57dc3884c064edeb9aef913b17b8c21e17192772fde12b1e0dde38d173ebb7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dab91f8491dfe0d5ac8711b11c00c4e1cc77d71a55cba22a54328cf9f42ee45a.jpeg",
    "https://cdn.faire.com/fastly/22eb48294e4d1be62b7261dbb70ed7fbabda2e9c8afb01c59fa7008c9bb3a60f.webp",
    "https://cdn.faire.com/fastly/b2d5fc9352c64b2522930c8c46215204fbd7a5f6c8592511778f20f42adfe7c3.webp",
    "https://cdn.faire.com/fastly/c07e04b847e069bbfd38949007f0860c47bc050275d8a6118c6233b69201bd66.jpeg",
  ],
  priceDollars: 3.46,
  description:
    "Elevate your style with the Colorful Evil Eye Gold Chain Necklace, a vibrant blend of modern design and ancient symbolism. This necklace features a colorful evil eye pendant set on a luxurious gold chain, offering both spiritual protection and a touch of elegance to any outfit.\nThe colorful evil eye pendant is designed with intricate details, combining a mix of vibrant hues to catch the eye and symbolize protection against negative energies.\nThe gold chain adds a touch of sophistication and complements the bold pendant, creating a perfect balance of modern style and traditional meaning.\nAdjustable for a personalized fit, this necklace is versatile enough for daily wear or special occasions.\nA perfect gift or statement piece, the Colorful Evil Eye Gold Chain Necklace blends protection with fashion, making it a must-have addition to your jewelry collection.",
  tags: [],
  msrpDollars: 11.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:59.468Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
